module.exports = __webpack_public_path__ + "static/media/homeproducts3.ca264206.png";